import { render, staticRenderFns } from "./Speed-Test.vue?vue&type=template&id=658de46e&"
import script from "./Speed-Test.vue?vue&type=script&lang=js&"
export * from "./Speed-Test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports